// Web crash reports for the own error log (T-1101, D40). The API scrubs everything again: these
// limits only cap what a client may send.
import { z } from 'zod';

export const CLIENT_ERROR_MESSAGE_MAX = 1000;
export const CLIENT_ERROR_STACK_MAX = 4000;
/** Per user; a crash loop must not flood the table. */
export const CLIENT_ERRORS_PER_MINUTE = 10;

export const clientErrorRequestSchema = z.strictObject({
	name: z.string().trim().min(1).max(100),
	message: z.string().max(CLIENT_ERROR_MESSAGE_MAX),
	stack: z.string().max(CLIENT_ERROR_STACK_MAX).optional(),
	/** `location.pathname` only, never the query string or hash. */
	path: z.string().max(200),
});

export const clientErrorResponseSchema = z.strictObject({ ok: z.literal(true) });

export type ClientErrorRequest = z.infer<typeof clientErrorRequestSchema>;
